import { MouseEvent } from 'react';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { TippyTooltip } from '@nx-frontend/shared/ui/tooltip';

export function CompleteTask({
  isDone,
  taskId,
  completeTask,
}: {
  isDone: boolean;
  taskId: string;
  completeTask: (taskId: string, done: boolean) => void;
}) {
  const onTaskCompleteClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    completeTask(taskId, !isDone);
  };

  return (
    <TippyTooltip message={isDone ? 'mark task incomplete' : 'mark task complete'}>
      <span
        className="fc-event-complete-status grow-0 shrink-0 group/calendar-task-complete flex items-center justify-center w-[16px]"
        onClick={onTaskCompleteClick}
      >
        {isDone ? (
          <Icon
            icon={IconsMap.CHECK_CIRCLE_FILL}
            className="icon text-neutral-500 block group-hover/calendar-task-complete:opacity-75 w-[14px] max-w-full"
          />
        ) : (
          <>
            <Icon
              icon={IconsMap.CHECK_CIRCLE}
              className="icon text-teal-500 hidden group-hover/calendar-task-complete:block w-full"
            />
            <Icon
              icon={IconsMap.CIRCLE}
              className="icon text-neutral-500 block group-hover/calendar-task-complete:hidden w-full"
            />
          </>
        )}
      </span>
    </TippyTooltip>
  );
}
